/**
 * Osd tv.
 */

'use strict';

var id   = 'pageMain',
    Page = require('stb-component-page'),
    page = new Page({$node: document.getElementById(id)}),
    $time = document.getElementById('time'),
    $number = document.getElementById('number'),
    $name = document.getElementById('title'),
    icons = {
        favorite: document.getElementById('icon-favorite'),
        ts: document.getElementById('icon-ts'),
        pvr: document.getElementById('icon-pvr'),
        censored: document.getElementById('icon-censored')
    },
    visible = false,
    // currentIntent,
    displayTimer;


console.log('===== OSD-TV START =====', 'green');

function display ( config, cb ) {
    $number.innerText = config.number || '';
    $name.innerText = config.name || '';
    // $favorite.innerHTML = config.favorite ? 'C' : '&nbsp;';
    if ( config.favorite ) {
        icons.favorite.classList.remove('hidden');
    } else {
        icons.favorite.classList.add('hidden');
    }

    if ( config.timeshift ) {
        icons.ts.classList.remove('hidden');
    } else {
        icons.ts.classList.add('hidden');
    }

    if ( config.pvr ) {
        icons.pvr.classList.remove('hidden');
    } else {
        icons.pvr.classList.add('hidden');
    }

    if ( config.censored ) {
        icons.censored.classList.remove('hidden');
    } else {
        icons.censored.classList.add('hidden');
    }


    clearTimeout(displayTimer);
    if ( config.attach ) {
        if ( visible ) {
            visible = false;

            cb(false, {});
            setTimeout(function () {
                core.call('hide');
            }, 0);
        } else {
            visible = true;
        }
    } else {
        visible = true;
        displayTimer = setTimeout(function () {
            console.log('visible? : ' + core.applicationState.visible);

            if ( core.applicationState.visible ) {
                core.call('hide');
            }
            //
            visible = false;
        }, 5000);
    }
    core.call('show');

    cb(false, {});
}

function showTime () {
    var time = new Date();

    $time.innerText = ( '0' + time.getHours()).slice(-2) + ':' + ( '0' + time.getMinutes()).slice(-2);
}

core.addListener('intent', function ( intent, cb ) {
    // hack
    // if intent close need to hide osd
    intent.addListener('close', function () {
        setTimeout(function () { core.call('hide'); }, 0);
    });

    // currentIntent = intent;
    switch ( intent.action ) {
        case 'osd-tv':
            display(intent.data, cb);
            break;
    }
});

showTime();

setInterval(showTime, 35000);

window.core.addListener('hide', function () {
    window.core.call('hide');
});

// public
module.exports = page;
